import React, { useEffect, useState } from "react";
import styles from "../styles/ResetPasswordForm.css";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios"; // <-- FIX 1: Import axios to make API calls

// <-- FIX 2: Define the base URL for your API. It's best practice to store this in a .env file.
const API_URL = `${process.env.REACT_APP_NODE_URL}/api`; // Adjust if your backend URL or port is different

const ResetPasswordForm = () => {
  const location = useLocation();
  const [email, setEmail] = useState("");
  // <-- FIX 3: Add state for loading, success messages, and errors
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    localStorage.clear();
    if (location.state?.email) {
      setEmail(location.state.email);
    }
  }, [location]);
  const navigate = useNavigate();

  // The function is already async, which is correct
  const handleSendResetLink = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage(""); // Clear previous messages
    setError("");

    try {
      // Call your backend's /forgot-password endpoint.
      // NOTE: Your backend route is "/forgot-password", but your code had "/password-forgot". I've used the more standard one.
      const response = await axios.post(`${API_URL}/password-forgot`, {
        email,
      });
      setMessage(response.data.message); // Set the success message from the API
    } catch (err) {
      // Handle errors gracefully
      const errorMessage =
        err.response?.data?.message ||
        "An error occurred. Please try again later.";
      setError(errorMessage);
    } finally {
      setIsLoading(false); // Stop the loading state
    }
  };

  const handleBackToLogin = () => {
    navigate("/login");
  };

  // <-- FIX 4: Improve navigation to prevent page reload
  const handleRegister = (e) => {
    e.preventDefault();
    navigate("/register");
  };

  return (
    <div className="reset-main-container">
      <div className="reset-password-container">
        <h1 className="reset-password-title">Reset Your Password</h1>
        <p className="reset-password-subtitle">
          Enter your email to receive a password reset link
        </p>

        <form onSubmit={handleSendResetLink} className="reset-password-form">
          <label htmlFor="email" className="reset-password-label">
            Email address
          </label>
          <div className="reset-password-input-wrapper">
            <span className="reset-password-input-icon">@</span>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your registered email"
              required
              className="reset-password-input"
            />
          </div>

          {/* <-- FIX 5: Display feedback messages to the user --> */}
          {message && <p className="success-message">{message}</p>}
          {error && <p className="error-message">{error}</p>}

          <p className="reset-password-helper-text">
            We'll send a password reset link to this email
          </p>

          {/* <-- FIX 6: Disable button during loading and show dynamic text --> */}
          <button
            type="submit"
            className="reset-password-send-button"
            disabled={isLoading}
          >
            {isLoading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>

        <div className="reset-password-or-separator">
          <span className="reset-password-or-text">Or</span>
        </div>

        <button
          onClick={handleBackToLogin}
          className="reset-password-back-button"
        >
          <span className="reset-password-back-icon">←</span> Back to Login
        </button>
      </div>
    </div>
  );
};

export default ResetPasswordForm;
